import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { from, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { MsalService } from '@azure/msal-angular';
import { AppConfigService } from '../config/app-config.service';
import { User } from '../models/user.model';

@Injectable({ providedIn: 'root' })
export class AuthService {
    private readonly userDataKey = 'userData';

    constructor(private msalService: MsalService, private configService: AppConfigService) { }

    getHeaders(): Observable<HttpHeaders> {
        return from(
            this.msalService.acquireTokenSilent({
                scopes: [this.configService.value.scope],
                account: this.msalService.instance.getActiveAccount() ?? undefined
            })
        ).pipe(
            map(result =>
                new HttpHeaders({
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${result.accessToken}`,
                })
            ),
            // opcional: capturar error de token
            // catchError(err => throwError(() => new Error('No se pudo obtener token')))
        );
    }

    getDataUser(): User | null {
        const userData = sessionStorage.getItem(this.userDataKey);

        if (!userData) {
            return null;
        }

        try {
            return JSON.parse(userData) as User;
        } catch {
            return null;
        }
    }

    setDataUser(user: User): void {
        sessionStorage.setItem(this.userDataKey, JSON.stringify(user));
    }

    clearDataUser(): void {
        sessionStorage.removeItem(this.userDataKey);
    }

    hasModule(moduleId: number): boolean {
        const modulesId = this.getDataUser()?.modulesId ?? [];
        return modulesId.includes(moduleId);
    }

    hasAnyModule(moduleIds: number[]): boolean {
        if (!moduleIds.length) {
            return true;
        }

        return moduleIds.some(moduleId => this.hasModule(moduleId));
    }

    hasAction(actionId: number): boolean {
        const actionsId = this.getDataUser()?.actionsId ?? [];
        return actionsId.includes(actionId);
    }

    hasAnyAction(actionIds: number[]): boolean {
        if (!actionIds.length) {
            return true;
        }

        return actionIds.some(actionId => this.hasAction(actionId));
    }


}
